export default "__VITE_ASSET__BqKYK2b2__"